import {
  Component,
  OnInit,
  TemplateRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { AppService } from "../../services/app.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Router, NavigationEnd } from "@angular/router";
import { SupportService } from "../../services/support-service";
import { Location } from "@angular/common";
import { DatePipe } from "@angular/common";
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit {
  @Output() sidemenuToggle = new EventEmitter<boolean>();
  @Output() sidemenuToggleForAdmin = new EventEmitter<boolean>();

  showhideSideMenu = false;
  selectedlang: any = [];
  testCentername = "Imaging Center";
  testCentername2 = "IC Admin";
  tcCountry: any = "";
  headerSubLittle: any = "";
  loginUserName = "";
  currentURL: any = "";
  adminSideMenu = false;
  constructor(
    private appservice: AppService,
    private modalService: BsModalService,
    private router: Router,
    private location: Location,
    private supportService: SupportService,
    private datePipe:DatePipe
  ) { }
  modalRef: BsModalRef;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  notificaitonEntity: any;
  unreadcount = 0;
  getNotificaiton(id) {
    if (id) {
      sessionStorage.setItem("testid", id);
    } else {
      id = sessionStorage.getItem("testid");
    }
    var data = {
      tcId: id,
      pageNumber: 1,
      pageRecord: 5
    }
    this.appservice.getNotification(data).subscribe(res => {
      this.notificaitonEntity = [];
      if(res["entity"]){
        this.notificaitonEntity = res["entity"];
        if(this.notificaitonEntity){
          for (let index = 0; index < this.notificaitonEntity.length; index++) {
            this.notificaitonEntity[index].description = "The appointment scheduled at "+this.datePipe.transform(this.notificaitonEntity[index].scheduleAppointment.scheduledOnStr,"MMM dd, yyyy")+" "+this.notificaitonEntity[index].scheduleAppointment.scheduleFromTime
            +" has been cancelled. The appointment added by the patient in waiting list, kindly check with patient and make as appointment confirm."
          }
        }
      
        console.log(this.notificaitonEntity);
        this.unreadcount = res["readcount"];
      }
     
    })

    if (localStorage.getItem("accesstoken")) {
      setTimeout(() => {
        this.getNotificaiton('');
      }, 60000);
    }
  }

  navigatetowaitList(listobj) {
    console.log(listobj);
    localStorage.setItem("fromTime", listobj.scheduleAppointment.scheduleFromTime);
    localStorage.setItem("toTime", listobj.scheduleAppointment.scheduleToTime);
    localStorage.setItem("scheduleDate", listobj.scheduleAppointment.scheduledOnStr);
    this.appservice.readNotification(listobj.id).subscribe(res => {
    })
    this.router.navigate([localStorage.getItem("testCode").toString() + '/waiting-list-history']);
  }

  ngOnInit() {
    this.loginUserName = sessionStorage.getItem('usertypename');
    this.viewTestCenter();
    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });
    this.checkURL("basicinfo");
    this.supportService.testCenterName.subscribe((res) => {
      if (res) {
        if (
          sessionStorage.getItem("usertype") &&
          sessionStorage.getItem("usertype") == "1"
        ) {
          this.testCentername = "Super Admin";
        } else {
          this.testCentername = res;
        }
      }
    });
    this.supportService.testCenterNameDropdown.subscribe((res) => {
      if (res) {
        if (
          sessionStorage.getItem("usertype") &&
          sessionStorage.getItem("usertype") == "1"
        ) {
          this.testCentername2 = "Admin";
        } else {
          this.testCentername2 = res;
        }
      }
    });

    this.supportService.headerSubLittle.subscribe((res) => {
      if (res) {
        if (
          sessionStorage.getItem("usertype") &&
          sessionStorage.getItem("usertype") == "1"
        ) {
          this.headerSubLittle = "Dashboard";
        } else {
          this.headerSubLittle = res;
        }
      }
    });

    this.supportService.loginUserName.subscribe((res) => {
      if (res) {
        if (
          sessionStorage.getItem("usertype") &&
          sessionStorage.getItem("usertype") == "1"
        ) {
          this.loginUserName = "TC Admin";
        } else {
          this.loginUserName = res;
        }
      }
    });

    this.router.events.subscribe((val) => {
      const navEnd = val instanceof NavigationEnd;
      if (navEnd) {
        this.titleChange();
      }
    });
    this.titleChange();
  }


  titleChange() {
    if (
      sessionStorage.getItem("usertype") &&
      sessionStorage.getItem("usertype") == "1"
    ) {
      this.loginUserName = "Super Admin";
    } else {
      const path = this.location.path().split("/");
      if (path.length === 3) {
        const router = path[2];
        if (router) {
          if (router == "home-calendar") {
            this.currentURL = "Dashboard";
          } else if (
            router == "basicinfo" ||
            router == "technician" ||
            router == "equipments" ||
            router == "procedure" ||
            router == "profile-photos" ||
            router == "insurance" ||
            router == "time-slot-settings" ||
            router == "medical-questions" ||
            router == "front-desk"
          ) {
            this.currentURL = "basicinfo";
            this.headerSubLittle = "Imaging Center Profile";
          } else if (
            router == "vacation-management" ||
            router == "vacation-history" ||
            router === "technician-schedule" ||
            router === "work-hours"
          ) {
            this.currentURL = "vacation-management";
            this.headerSubLittle = "Technologist Management";
          } else if (
            router === "schedule-appointment" ||
            router === "confirming-details" ||
            router === "check-in-patient" ||
            router === "waiting-list" ||
            router === "cancel-noshow" ||
            router === "waiting-list-history"
          ) {
            this.headerSubLittle = "Scheduling Appointment";
          } else if (
            router === "plan-subscription" ||
            router === "credit-card" ||
            router === "billing-summary" ||
            router === "billing-reports" ||
            router === "hold-or-cancel"
          ) {
            this.headerSubLittle = "SchedMed Plans";
          } else if (
            router === "patient-info" ||
            router === "patient-type" ||
            router === "authorization-status" ||
            router === "imaging-center-patients" ||
            router === "schedmed-patient"
          ) {
            this.headerSubLittle = "Patient Information";
          } else if (router === "physician-information") {
            this.headerSubLittle = "Physician Information";
          } else if (
            router === "patient-review" ||
            router === "physician-review"
          ) {
            this.headerSubLittle = "Review";
          } else if (
            router === "report-log" ||
            router === "insurance-billing" ||
            router === "checked-in-patient" ||
            router === "noshow-patient" ||
            router === "cancelled-report"
          ) {
            this.headerSubLittle = "Report";
          } else if (router === "cancel-appointments") {
            this.headerSubLittle = "Cancel/Block Appointments";
          } else if (
            router === "utilization" ||
            router === "equipment-breakdown" ||
            router === "calls-using-schedmed" ||
            router === "analysis-appointments"
          ) {
            this.headerSubLittle = "Analysis";
          }
        }
      }
    }
  }


  userType:any = '';
  subscritionBal = 0;
  viewTestCenter() {
    this.userType = sessionStorage.getItem("usertype");
    if (
      sessionStorage.getItem("usertype") &&
      sessionStorage.getItem("usertype") == "1"
    ) {
      this.loginUserName = "IC Admin";
      this.testCentername = "SchedMed Admin";
    } else {
      this.appservice.viewtestcenter().subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] == 200) {
            if (res["entity"]) {
              if (res['entity']['patBalanceAmount']) {
                this.subscritionBal += +res['entity']['patBalanceAmount'];
              }

              if (res['entity']['subBalanceAmount']) {
                this.subscritionBal += +res['entity']['subBalanceAmount'];
              }
              localStorage.setItem('subscritionBal', this.subscritionBal + '');

              this.getNotificaiton(res["entity"]["id"]);
              if (res["entity"]["name"]) {
                this.testCentername = res["entity"]["name"];
                this.testCentername2 = res["entity"]["name"];
              } else {
                this.testCentername = "Imaging Center";
                this.testCentername2 = "IC Admin";
              }

              localStorage.setItem("testCenterName", this.testCentername);

              if(sessionStorage.getItem("usertype") && sessionStorage.getItem("usertype") === "3"){
                this.appservice.getFrontDeskByFrontDeskId(localStorage.getItem("frontdesk")).subscribe(res=>{
                  if(res["entity"]){
                    this.loginUserName = res["entity"]["firstName"]+" "+res["entity"]["lastName"];
                  }else {
                    this.loginUserName = "User Name";
                  }
                })
              }else {
                if (
                  res["entity"]["primaryContactInfo"] &&
                  res["entity"]["primaryContactInfo"]["firstName"] &&
                  res["entity"]["primaryContactInfo"]["lastName"]
                ) {
                  this.loginUserName =
                    res["entity"]["primaryContactInfo"]["firstName"] +
                    " " +
                    res["entity"]["primaryContactInfo"]["lastName"];
                } else {
                  this.loginUserName = "IC Admin";
                }
  
              }
              
              localStorage.setItem("loginUserName", this.loginUserName);

              if (
                res["entity"] &&
                res["entity"].address &&
                res["entity"].address.state &&
                res["entity"].address.state.state
              ) {
                localStorage.setItem(
                  "stateName",
                  res["entity"].address.state.state
                );
                if (localStorage.getItem("stateName") != null) {
                  this.supportService.stateName.next(
                    localStorage.getItem("stateName")
                  );
                }
              }

              if (
                res["entity"] &&
                res["entity"].address &&
                res["entity"].address.country
              ) {
                this.tcCountry = res["entity"].address.country.id;
                localStorage.setItem(
                  "countryId",
                  res["entity"].address.country.id
                );
              } else {
                this.tcCountry = "";
                localStorage.setItem("countryId", null);
              }
              localStorage.setItem("testCenterId", res["entity"]["id"]);
              localStorage.setItem("offsetzone", res["entity"]["offSet"]);
              const data = {
                tcId: res["entity"]["id"],
                timeZoneId: res["entity"]["timeZoneId"],
              };

              this.appservice.updateTimeZone(data).subscribe((res) => ({}));
            }
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  checkURL(type) {
    if (type != null && sessionStorage.getItem("testCode") != null) {
      this.router.navigate([
        sessionStorage.getItem("testCode").toString().trim(),
        type,
      ]);
      this.menu();
    }
  }

  menu(): string {
    const obj = this;
    setTimeout(() => {
      const url = obj.router.url.toString().trim().split("/");
      obj.currentURL = url[2];
    }, 200);

    return this.currentURL;
  }

  signoutuser() {
    this.appservice.revoke().subscribe(
      (res) => {
        this.appservice.signout();
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  toggleSidemenu() {
    if (
      sessionStorage.getItem("usertype") &&
      sessionStorage.getItem("usertype") == "1"
    ) {
      this.adminSideMenu = !this.adminSideMenu;
      this.supportService.adminsidemenu.next(this.adminSideMenu);
    } else {
      this.sidemenuToggle.emit((this.showhideSideMenu = true));
    }
  }
}
